import { useEffect } from "react";
import $ from "jquery";
import "select2";
import { formatAmountFields } from "./amountFormat";

function syncSelect2FromNative(selectEl) {
  if (!selectEl || !$(selectEl).hasClass("select2-hidden-accessible")) return;
  $(selectEl).trigger("change");
}

function filterOccupancyOptions(selectot, propertyType, transactionType) {
  if (!selectot) return;
  const transactionValues = ["1", "2", "3", "4", "5", "6", "11"];
  const pt = String(propertyType || "");
  const txn = String(transactionType || "");
  const currentValue = String(selectot.value || "");

  for (const option of selectot.options) {
    const value = option.value;
    let visible = true;

    if (transactionValues.includes(txn)) {
      if (!pt && ["6", "7", "8"].includes(value)) visible = false;
      if ((pt === "1" || pt === "2") && !["1", "2", "3", ""].includes(value)) visible = false;
      if ((["3", "4", "6", "7", "8", "9", "10", "11", "12", "15", "17", "18", "19", "20"].includes(pt)) && !["2", "3", "4", ""].includes(value)) visible = false;
      if ((["5", "13", "14", "16"].includes(pt)) && !["6", "7", "8", ""].includes(value)) visible = false;
    }

    option.disabled = !visible;
    option.hidden = !visible;
    option.style.display = visible ? "" : "none";
  }

  if (currentValue) {
    const selectedOption = selectot.querySelector(`option[value="${CSS.escape(currentValue)}"]`);
    if (selectedOption && (selectedOption.disabled || selectedOption.hidden)) {
      selectot.value = "";
      syncSelect2FromNative(selectot);
    }
  }
}

function resetOccupancyTypeSelection() {
  const selectot = document.getElementById("occupancyInput");
  if (!selectot) return;
  selectot.value = "";
  syncSelect2FromNative(selectot);
}

function applyOccupancyFilters() {
  const propertySelect = document.getElementById("typeInput");
  const occupancySelect = document.getElementById("occupancyInput");
  const transactionSelect = document.getElementById("transactionInput");
  if (!propertySelect || !occupancySelect) return;
  filterOccupancyOptions(
    occupancySelect,
    propertySelect.value,
    transactionSelect?.value || ""
  );
}

function togglePriceFields() {
  const transactionSelect = document.getElementById("transactionInput");
  if (!transactionSelect) return;

  const selectedText = (
    transactionSelect.options[transactionSelect.selectedIndex]?.text || ""
  ).trim().toLowerCase();

  const purchaseWrapper = $("#purchasePriceWrapper");
  const currentWrapper = $("#currentPriceWrapper");

  if (selectedText === "purchase") {
    purchaseWrapper.show();
    $("#purchasePriceInput").prop("required", true);
    currentWrapper.hide();
    $("#currentPriceInput").prop("required", false);
  } else if (selectedText === "refinance") {
    purchaseWrapper.hide();
    $("#purchasePriceInput").prop("required", false);
    currentWrapper.show();
    $("#currentPriceInput").prop("required", true);
  } else {
    purchaseWrapper.hide();
    $("#purchasePriceInput").prop("required", false);
    currentWrapper.hide();
    $("#currentPriceInput").prop("required", false);
  }
}

const SteppersBehaviour = () => {

  useEffect(() => {

    const filler = document.getElementById('dynamic-filler');
    const rightCol = document.querySelector('.right');

    // ================================
    // ✅ SELECT2 INIT
    // ================================
    $(".select2-dropdown").each(function () {

      const $this = $(this);

      $this.select2({
        placeholder: $this.data('placeholder'),
        allowClear: true,
        width: '100%'
      });

      const title = $this.attr("title");
      if (title) {
        $this.next(".select2-container")
          .find(".select2-selection")
          .attr("title", title);
      }

      $this.on('select2:open', function () {
        $this.closest('.custom-floating').addClass('focused');
      });

      $this.on('select2:close', function () {
        $this.closest('.custom-floating').removeClass('focused');
      });

      $this.on('change', function () {
        const wrapper = $this.closest('.custom-floating');

        if ($this.val()) {
          wrapper.addClass('has-value');
          wrapper.removeClass('error');
        } else {
          wrapper.removeClass('has-value');
        }

        rightCol?.dispatchEvent(new Event('input', { bubbles: true }));
      });

      if ($this.val()) {
        $this.closest('.custom-floating').addClass('has-value');
      }
    });

    // ================================
    // ✅ GOOGLE MAPS PLACE AUTOCOMPLETE
    // ================================
    function loadGoogleMaps(callback) {
      if (window.google && window.google.maps) {
        callback();
        return;
      }

      const script = document.createElement("script");
      script.src = "https://maps.googleapis.com/maps/api/js?key=YOUR_KEY&libraries=places";
      script.async = true;
      script.defer = true;
      script.onload = callback;
      document.body.appendChild(script);
    }

    loadGoogleMaps(() => {
      const propertyInput = document.getElementById("propertyInput");
      if (propertyInput) {
        const autocomplete = new window.google.maps.places.Autocomplete(propertyInput, {
          types: ["address"],
          componentRestrictions: { country: "us" }
        });

        autocomplete.addListener("place_changed", () => {
          const place = autocomplete.getPlace();
          if (!place.geometry) return;
          console.log("Selected address:", place.formatted_address);
        });
      }
    });
    // ================================
    // ✅ PROGRESS BAR
    // ================================
    rightCol?.addEventListener('input', () => {

      const activeStep = document.querySelector('.form-step:not(.d-none)');
      if (!activeStep) return;

      const stepId = activeStep.id;
      const inputs = activeStep.querySelectorAll('.count-progress');
      const totalInputs = inputs.length;

      let filledCount = 0;

      inputs.forEach(input => {
        if (input.value && input.value.trim() !== "") {
          filledCount++;
        }
      });

      let progress = 0;

      if (stepId === 'step-1') {
        progress = 25 + (filledCount / totalInputs * 25);
      } else if (stepId === 'step-2') {
        progress = 50 + (filledCount / totalInputs * 50);
      }

      if (filler) filler.style.width = progress + "%";
    });

    togglePriceFields();
    applyOccupancyFilters();
    formatAmountFields(["loanInput", "purchasePriceInput", "currentPriceInput"]);

    if (window.App && window.App.refreshInputAdornments) {
      window.App.refreshInputAdornments(document.querySelector(".right") || document);
    }

    const $transactionInput = $("#transactionInput");
    $transactionInput.on("change select2:select", function () {
      togglePriceFields();
      applyOccupancyFilters();
      if (window.App && window.App.refreshInputAdornments) {
        window.App.refreshInputAdornments(document.getElementById("step-2") || document);
      }
    });

    const $propertyInput = $("#typeInput");
    $propertyInput.on("change select2:select", function () {
      resetOccupancyTypeSelection();
      applyOccupancyFilters();
    });

    $("#occupancyInput").on("change select2:select", function () {
      const propertySelect = document.getElementById("typeInput");
      const occupancySelect = document.getElementById("occupancyInput");
      const pt = String(propertySelect?.value || "");
      const ot = String(occupancySelect?.value || "");
      if (ot === "1" && (pt === "1" || pt === "2")) {
        resetOccupancyTypeSelection();
        applyOccupancyFilters();
      }
    });

    // ================================
    // ✅ FORM VALIDATION
    // ================================
    const step1Form = document.getElementById("financing-form");

step1Form?.addEventListener("submit", function(e) {
    e.preventDefault();

    const fields = step1Form.querySelectorAll(".required-input, select[required]");
    let isValid = true;

    fields.forEach(f => {
        const wrapper = f.closest(".custom-floating");
        if (!f.value || f.value.trim() === "") {
            wrapper.classList.add("error");
            isValid = false;
        } else {
            wrapper.classList.remove("error");
        }
    });

    if (!isValid) return;

    // AJAX submit
    const formData = new FormData(step1Form);
    fetch("", {
        method: "POST",
        headers: {
            "X-CSRFToken": formData.get("csrfmiddlewaretoken")
        },
        body: formData
    })
    .then(res => res.json())
    .then(data => {
        if (data.success && data.next_step === 2) {
            nextStep(2); // move to Step 2
        }
    });
});

  }, []);

  return null;
};

// ✅ IMPORTANT FIX
export default SteppersBehaviour;


// ================================
// ✅ STEP FUNCTION (outside component)
// ================================
function nextStep(stepNumber) {

  document.querySelectorAll('.form-step').forEach(step => {
    step.classList.add('d-none');
  });

  document.getElementById('step-' + stepNumber)?.classList.remove('d-none');

  if (stepNumber === 2) {
    togglePriceFields();
    formatAmountFields(["purchasePriceInput", "currentPriceInput"]);
    if (window.App && window.App.refreshInputAdornments) {
      const stepEl = document.getElementById("step-" + stepNumber);
      window.App.refreshInputAdornments(stepEl || document);
    }
  }

  const filler = document.getElementById('dynamic-filler');

  if (filler) {
    filler.style.width = stepNumber === 2 ? "50%" : "25%";
  }
}
